import React from 'react'

function Places() {
  return (
    <div>Places</div>
  )
}

export default Places